module.exports = __webpack_public_path__ + "img/products_big_can_bubblegum_ru.4ffb9da7.png";